<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">Sobre el ataque que se está atendiendo</h4>

    <form-group :error="errors.has('fecha-ataque')">
      <datetime
        :disabled="!editando"
        v-model="form.fechaAtaque"
        v-validate="'required'"
        :use12-hour="true"
        input-class="form__input"
        name="fecha-ataque"
        value-zone="local"
        type="date"/>
      <label class="form__label form__label--required">19. ¿En qué fecha se dio el ataque?</label>
    </form-group>

    <form-group :error="errors.has('momento-ataque') && submitted">
      <label class="form__label form__label--required">
        20. Momento del ataque
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.momentoAtaque"
        id="deDiamomentoAtaque"
        name="momento-ataque"
        v-validate="'required'"
        value="De día">
        <label class="form__label" for="deDiamomentoAtaque">De día</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.momentoAtaque"
        id="deNochemomentoAtaque"
        name="momento-ataque"
        v-validate="'required'"
        value="De noche">
        <label class="form__label" for="deNochemomentoAtaque">De noche</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.momentoAtaque"
        id="nsnrmomentoAtaque"
        name="momento-ataque"
        v-validate="'required'"
        value="NS/NR">
        <label class="form__label" for="nsnrmomentoAtaque">
          NS/NR
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('tipo-perro') && submitted">
      <label class="form__label form__label--required">
        21. Raza del perro atacada
      </label>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="zaguatetiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Zaguate">
        <label class="form__label" for="zaguatetiposPerrosAtacados">Zaguate</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="akitatiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Akita">
        <label class="form__label" for="akitatiposPerrosAtacados">Akita</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="beagletiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Beagle">
        <label class="form__label" for="beagletiposPerrosAtacados">Beagle</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="boxertiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Boxer">
        <label class="form__label" for="boxertiposPerrosAtacados">Boxer</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="bulldogtiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Bulldog">
        <label class="form__label" for="bulldogtiposPerrosAtacados">Bulldog</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="bullterriertiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Bull terrier">
        <label class="form__label" for="bullterriertiposPerrosAtacados">Bull terrier</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="chihuahatiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Chihuaha">
        <label class="form__label" for="chihuahatiposPerrosAtacados">Chihuaha</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="chowchowtiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Chow chow">
        <label class="form__label" for="chowchowtiposPerrosAtacados">Chow chow</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="cockertiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Cocker">
        <label class="form__label" for="cockertiposPerrosAtacados">Cocker</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="collietiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Collie">
        <label class="form__label" for="collietiposPerrosAtacados">Collie</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="dalmatatiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Dálmata">
        <label class="form__label" for="dalmatatiposPerrosAtacados">Dálmata</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="dobermantiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Doberman">
        <label class="form__label" for="dobermantiposPerrosAtacados">Doberman</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="foxterriertiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Fox terrier">
        <label class="form__label" for="foxterriertiposPerrosAtacados">Fox terrier</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="goldenretrievertiposPerrosAtacados"
        name="tipo-perro" v-model="form.tiposPerrosAtacados" value="Golden retriever">
        <label class="form__label" for="goldenretrievertiposPerrosAtacados">Golden retriever</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="grandanestiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Gran danés">
        <label class="form__label" for="grandanestiposPerrosAtacados">Gran danés</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="huskietiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Huskie siberiano">
        <label class="form__label" for="huskietiposPerrosAtacados">Huskie siberiano</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="labradortiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Labrador">
        <label class="form__label" for="labradortiposPerrosAtacados">Labrador</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="pastoralemantiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Pastor alemán">
        <label class="form__label" for="pastoralemantiposPerrosAtacados">Pastor alemán</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="pastorbelgatiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Pastor belga">
        <label class="form__label" for="pastorbelgatiposPerrosAtacados">Pastor belga</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="pekinestiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Pekinés">
        <label class="form__label" for="pekinestiposPerrosAtacados">Pekinés</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="pinshertiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Pinsher">
        <label class="form__label" for="pinshertiposPerrosAtacados">Pinsher</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="pitbulltiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Pitbull">
        <label class="form__label" for="pitbulltiposPerrosAtacados">Pitbull</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="pugtiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Pug">
        <label class="form__label" for="pugtiposPerrosAtacados">Pug</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="rottweilertiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Rottweiler">
        <label class="form__label" for="rottweilertiposPerrosAtacados">Rottweiler</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="schnauzertiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Schnauzer">
        <label class="form__label" for="schnauzertiposPerrosAtacados">Schnauzer</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="sharpeitiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Sharpei">
        <label class="form__label" for="sharpeitiposPerrosAtacados">Sharpei</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="otrotiposPerrosAtacados" name="tipo-perro"
        v-model="form.tiposPerrosAtacados" value="Otra">
        <label class="form__label" for="otrotiposPerrosAtacados">
          Otro / Comentarios adicionales
        </label>
      </div>

      <div class="identado">
        <form-group :error="errors.has('otro-perro-atacado') && submitted"
        v-if="form.tiposPerrosAtacados.includes('Otra')">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.otroPerroAtacado"
          name="otro-perro-atacado"
          required
          v-validate="'required'">
          <label class="form__label">
            Especifique cual otra:
          </label>
        </form-group>
        <form-group class="mb-0" :error="errors.has('funcion-perro-atacado') && submitted">
          <label class="form__label form__label--required">
            21.1 La función principal del perro atacado es:
          </label>
          <div class="radio radio--azul">
            <input
            :disabled="!editando"
            type="radio"
            v-model="form.funcionPerroAtacado"
            id="mascotafuncionPerroAtacado"
            name="funcion-perro-atacado"
            v-validate="'required'"
            value="Mascota">
            <label class="form__label" for="mascotafuncionPerroAtacado">Mascota</label>
          </div>
          <div class="radio radio--azul">
            <input
            :disabled="!editando"
            type="radio"
            v-model="form.funcionPerroAtacado"
            id="cuidoproteccionfuncionPerroAtacado"
            name="funcion-perro-atacado"
            v-validate="'required'"
            value="Cuido/protección">
            <label class="form__label" for="cuidoproteccionfuncionPerroAtacado">
              Cuido/protección
            </label>
          </div>
          <div class="radio radio--azul">
            <input
            :disabled="!editando"
            type="radio"
            v-model="form.funcionPerroAtacado"
            id="pastoreofuncionPerroAtacado"
            name="funcion-perro-atacado"
            v-validate="'required'"
            value="Ayuda como pastor/arriero">
            <label class="form__label" for="pastoreofuncionPerroAtacado">
              Ayuda como pastor/arriero
            </label>
          </div>
        </form-group>
      </div>
    </form-group>

    <form-group :error="errors.has('edad-perro') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="number"
      class="form__input"
      v-model.number="form.edadPerro"
      required
      name="edad-perro"
      v-validate="'required'">
      <label class="form__label">22. Edad del perro atacado</label>
      <form-group class="my-0" :error="errors.has('unidad-edad-perro') && submitted">
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.unidadEdadPerro"
          id="edadPerroAnos"
          name="unidad-edad-perro"
          v-validate="'required'"
          value="años">
          <label class="form__label" for="edadPerroAnos">Años</label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.unidadEdadPerro"
          id="edadPerroMeses"
          name="unidad-edad-perro"
          v-validate="'required'"
          value="meses">
          <label class="form__label" for="edadPerroMeses">Meses</label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.unidadEdadPerro"
          id="edadPerroDias"
          name="unidad-edad-perro"
          v-validate="'required'"
          value="días">
          <label class="form__label" for="edadPerroDias">Días</label>
        </div>
      </form-group>
    </form-group>

    <form-group :error="errors.has('sexo-animal-atacado') && submitted">
      <label class="form__label form__label--required">
        23. Sexo del animal atacado
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.sexoAnimalAtacado"
        id="machosexoAnimalAtacado"
        name="sexo-animal-atacado"
        v-validate="'required'"
        value="Macho">
        <label class="form__label" for="machosexoAnimalAtacado">Macho</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.sexoAnimalAtacado"
        id="hembrasexoAnimalAtacado"
        name="sexo-animal-atacado"
        v-validate="'required'"
        value="Hembra">
        <label class="form__label" for="hembrasexoAnimalAtacado">
          Hembra
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('peso-animal-atacado') && submitted">
      <label class="form__label form__label--required">
        24. Peso en kilogramos del animal atacado
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="menos2kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="Menos de 2kg">
        <label class="form__label" for="menos2kgpesoAnimalAtacado">Menos de 2kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="2kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="2kg">
        <label class="form__label" for="2kgpesoAnimalAtacado">2kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="4kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="4kg">
        <label class="form__label" for="4kgpesoAnimalAtacado">4kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="6kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="6kg">
        <label class="form__label" for="6kgpesoAnimalAtacado">6kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="8kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="8kg">
        <label class="form__label" for="8kgpesoAnimalAtacado">8kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="10kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="10kg">
        <label class="form__label" for="10kgpesoAnimalAtacado">10kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="12kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="12kg">
        <label class="form__label" for="12kgpesoAnimalAtacado">12kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="14kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="14kg">
        <label class="form__label" for="14kgpesoAnimalAtacado">14kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="16kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="16kg">
        <label class="form__label" for="16kgpesoAnimalAtacado">16kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="18kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="18kg">
        <label class="form__label" for="18kgpesoAnimalAtacado">18kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="20kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="20kg">
        <label class="form__label" for="20kgpesoAnimalAtacado">20kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="mayor20kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="Más de 20kg">
        <label class="form__label" for="mayor20kgpesoAnimalAtacado">Más de 20kg</label>
      </div>
      <div class="identado" v-if="form.pesoAnimalAtacado === 'Más de 20kg'">
        <form-group :error="errors.has('otro-peso-animal-atacado') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="number"
          class="form__input"
          v-model.number="form.otroPesoAnimalAtacado"
          name="otro-peso-animal-atacado"
          required
          v-validate="'required'">
          <label class="form__label">
            ¿Aproximadamente cuántos kg?
          </label>
        </form-group>
      </div>
    </form-group>

    <form-group :error="errors.has('salud-atacado') && submitted">
      <label class="form__label form__label--required">
        25. Estado de salud/condición del animal atacado
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="sanokgsaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Sano">
        <label class="form__label" for="sanokgsaludAnimalAtacado">Sano</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="enfermosaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Enfermo">
        <label class="form__label" for="enfermosaludAnimalAtacado">Enfermo</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="lesionadosaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Lesionado">
        <label class="form__label" for="lesionadosaludAnimalAtacado">Lesionado</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="preñadasaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Preñada">
        <label class="form__label" for="preñadasaludAnimalAtacado">Preñada</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="recienparidasaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Recién parida">
        <label class="form__label" for="recienparidasaludAnimalAtacado">Recién parida</label>
      </div>
    </form-group>

    <form-group :error="errors.has('resultado-ataque') && submitted">
      <label class="form__label form__label--required">
        26. Resultado del ataque
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.resultadoAnimalAtacado"
        id="1resultadoAnimalAtacado"
        name="resultado-ataque"
        v-validate="{ required: !form.resultadoAnimalAtacadoCheckOtro }"
        value="Herido y luego murió">
        <label class="form__label" for="1resultadoAnimalAtacado">Herido y luego murió</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.resultadoAnimalAtacado"
        id="2resultadoAnimalAtacado"
        name="resultado-ataque"
        v-validate="{ required: !form.resultadoAnimalAtacadoCheckOtro }"
        value="Herido pero sigue vivo">
        <label class="form__label" for="2resultadoAnimalAtacado">Herido pero sigue vivo</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.resultadoAnimalAtacado"
        id="3resultadoAnimalAtacado"
        name="resultado-ataque"
        v-validate="{ required: !form.resultadoAnimalAtacadoCheckOtro }"
        value="Muerto pero no comió">
        <label class="form__label" for="3resultadoAnimalAtacado">Muerto pero no comió</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.resultadoAnimalAtacado"
        id="4resultadoAnimalAtacado"
        name="resultado-ataque"
        v-validate="{ required: !form.resultadoAnimalAtacadoCheckOtro }"
        value="Muerto y comido">
        <label class="form__label" for="4resultadoAnimalAtacado">Muerto y comido</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.resultadoAnimalAtacadoCheckOtro"
        id="5resultadoAnimalAtacado">
        <label class="form__label" for="5resultadoAnimalAtacado">
          Otro / Comentarios adicionales
        </label>
      </div>

      <div class="identado" v-if="form.resultadoAnimalAtacadoCheckOtro">
        <form-group :error="errors.has('otra-resultado-ataque') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.otroResultadoAnimalAtacado"
          name="otra-resultado-ataque"
          required
          v-validate="'required'">
          <label class="form__label">
            Especifique:
          </label>
        </form-group>
      </div>

      <div class="identado" v-if="form.resultadoAnimalAtacado === 'Muerto y comido'">
        <form-group :error="errors.has('partes-consumidas') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.partesConsumidas"
          name="partes-consumidas"
          required
          v-validate="'required'">
          <label class="form__label">
            ¿Cuáles partes fueron consumidas?
          </label>
        </form-group>
      </div>

      <div class="identado" v-if="form.resultadoAnimalAtacado === 'Herido pero sigue vivo'">
        <form-group :error="errors.has('utilizoMedicamento') && submitted">
          <label class="form__label form__label--required">
            ¿Utilizó algún medicamento o algo para curar?
          </label>
          <div class="radio radio--azul">
            <input
            :disabled="!editando"
            type="radio"
            v-model="form.utilizoMedicamento"
            id="siutilizoMedicamento"
            name="utilizoMedicamento"
            v-validate="'required'"
            :value="true">
            <label class="form__label" for="siutilizoMedicamento">
              Si
            </label>
          </div>
          <div class="radio radio--azul">
            <input
            :disabled="!editando"
            type="radio"
            v-model="form.utilizoMedicamento"
            id="noutilizoMedicamento"
            name="utilizoMedicamento"
            v-validate="'required'"
            :value="false">
            <label class="form__label" for="noutilizoMedicamento">
              No
            </label>
          </div>
          <form-group :error="errors.has('valor-medicamento') && submitted"
          v-if="form.utilizoMedicamento">
            <input
            data-vv-validate-on="blur"
            :disabled="!editando"
            type="number"
            class="form__input"
            v-model.number="form.valorMedicamento"
            name="valor-medicamento"
            required
            v-validate="'required'">
            <label class="form__label">
              Valor aproximado de los medicamentos que compró
            </label>
          </form-group>
          <form-group :error="errors.has('medicamentos-utilizados') && submitted"
          v-if="form.utilizoMedicamento">
            <input
            data-vv-validate-on="blur"
            :disabled="!editando"
            type="text"
            class="form__input"
            v-model="form.medicamentoUtilizado"
            name="medicamentos-utilizados"
            required
            v-validate="'required'">
            <label class="form__label">
              ¿Cuáles medicamentos utilizó?
            </label>
          </form-group>
        </form-group>
      </div>
    </form-group>

    <form-group>
      <label class="form__label form__label--opcional">
        27. Solo si el animal atacado murió, este estaba cubierto o
        semicubierto con vegetación (como si le pusieron vegetación
        encima intencionadamente para esconderlo)
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.victimaCubierta"
        id="sivictimaCubierta"
        name="victimaCubierta"
        :value="true">
        <label class="form__label" for="sivictimaCubierta">
          Si
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.victimaCubierta"
        id="novictimaCubierta"
        name="victimaCubierta"
        :value="false">
        <label class="form__label" for="novictimaCubierta">
          No
        </label>
      </div>
    </form-group>

    <form-group>
      <label class="form__label form__label--opcional">
        28. Solo si el animal atacado murió, cree usted que el depredador
        arrastró la presa (la mató en un punto X y la arrastró a un punto Y)
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.victimaArrastrada"
        id="sivictimaArrastrada"
        name="victimaArrastrada"
        :value="true">
        <label class="form__label" for="sivictimaArrastrada">
          Si
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.victimaArrastrada"
        id="novictimaArrastrada"
        name="victimaArrastrada"
        :value="false">
        <label class="form__label" for="novictimaArrastrada">
          No
        </label>
      </div>
      <form-group class="identado" :error="errors.has('distVictimaArrastrada') && submitted"
      v-if="form.victimaArrastrada">
        <label class="form__label form__label--required">
          ¿Cuántos metros?
        </label>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="menos25mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="Menos de 25m">
          <label class="form__label" for="menos25mdistVictimaArrastrada">
            Menos de 25m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="25mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="25m">
          <label class="form__label" for="25mdistVictimaArrastrada">
            25m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="50mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="50m">
          <label class="form__label" for="50mdistVictimaArrastrada">
            50m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="75mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="75m">
          <label class="form__label" for="75mdistVictimaArrastrada">
            75m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="100mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="100m">
          <label class="form__label" for="100mdistVictimaArrastrada">
            100m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="125mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="125m">
          <label class="form__label" for="125mdistVictimaArrastrada">
            125m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="150mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="150m">
          <label class="form__label" for="150mdistVictimaArrastrada">
            150m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="175mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="175m">
          <label class="form__label" for="175mdistVictimaArrastrada">
            175m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="200mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="200m">
          <label class="form__label" for="200mdistVictimaArrastrada">
            200m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="225mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="225m">
          <label class="form__label" for="225mdistVictimaArrastrada">
            225m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="250mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="250m">
          <label class="form__label" for="250mdistVictimaArrastrada">
            250m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="275mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="275m">
          <label class="form__label" for="275mdistVictimaArrastrada">
            275m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="300mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="300m">
          <label class="form__label" for="300mdistVictimaArrastrada">
            300m
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.distVictimaArrastrada"
          id="mas300mdistVictimaArrastrada"
          name="distVictimaArrastrada"
          v-validate="'required'"
          value="Más de 300m">
          <label class="form__label" for="mas300mdistVictimaArrastrada">
            Más de 300m
          </label>
        </div>
      </form-group>
    </form-group>

    <form-group :error="errors.has('distHumanos') && submitted">
      <label class="form__label form__label--required">
        29. Distancia en metros entre el sitio del ataque y la casa o
        infraestructura habitada por humanos más cercana
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="menos50mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="Menos de 50m">
        <label class="form__label" for="menos50mdistHumanos">
          Menos de 50m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="50mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="50m">
        <label class="form__label" for="50mdistHumanos">
          50m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="100mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="100m">
        <label class="form__label" for="100mdistHumanos">
          100m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="150mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="150m">
        <label class="form__label" for="150mdistHumanos">
          150m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="200mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="200m">
        <label class="form__label" for="200mdistHumanos">
          200m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="250mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="250m">
        <label class="form__label" for="250mdistHumanos">
          250m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="300mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="300m">
        <label class="form__label" for="300mdistHumanos">
          300m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="350mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="350m">
        <label class="form__label" for="350mdistHumanos">
          350m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="400mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="400m">
        <label class="form__label" for="400mdistHumanos">
          400m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="450mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="450m">
        <label class="form__label" for="450mdistHumanos">
          450m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="500mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="500m">
        <label class="form__label" for="500mdistHumanos">
          500m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="550mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="550m">
        <label class="form__label" for="550mdistHumanos">
          550m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="600mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="600m">
        <label class="form__label" for="600mdistHumanos">
          600m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="650mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="650m">
        <label class="form__label" for="650mdistHumanos">
          650m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="700mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="700m">
        <label class="form__label" for="700mdistHumanos">
          700m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="750mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="750m">
        <label class="form__label" for="750mdistHumanos">
          750m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="800mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="800m">
        <label class="form__label" for="800mdistHumanos">
          800m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="850mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="850m">
        <label class="form__label" for="850mdistHumanos">
          850m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="900mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="900m">
        <label class="form__label" for="900mdistHumanos">
          900m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="950mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="950m">
        <label class="form__label" for="950mdistHumanos">
          950m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="1kdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="1km">
        <label class="form__label" for="1kdistHumanos">
          1km
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="mas1kdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="Más de 1km">
        <label class="form__label" for="mas1kdistHumanos">
          Más de 1km
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('distBosque') && submitted">
      <label class="form__label form__label--required">
        30. Distancia en metros entre el sitio del ataque y el bosque
        más cercano (parche de montaña o "monte")
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="menos50mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="Menos de 50m">
        <label class="form__label" for="menos50mdistBosque">
          Menos de 50m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="50mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="50m">
        <label class="form__label" for="50mdistBosque">
          50m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="100mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="100m">
        <label class="form__label" for="100mdistBosque">
          100m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="150mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="150m">
        <label class="form__label" for="150mdistBosque">
          150m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="200mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="200m">
        <label class="form__label" for="200mdistBosque">
          200m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="250mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="250m">
        <label class="form__label" for="250mdistBosque">
          250m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="300mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="300m">
        <label class="form__label" for="300mdistBosque">
          300m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="350mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="350m">
        <label class="form__label" for="350mdistBosque">
          350m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="350mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="350m">
        <label class="form__label" for="350mdistBosque">
          350m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="400mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="400m">
        <label class="form__label" for="400mdistBosque">
          400m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="450mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="450m">
        <label class="form__label" for="450mdistBosque">
          450m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="500mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="500m">
        <label class="form__label" for="500mdistBosque">
          500m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="550mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="550m">
        <label class="form__label" for="550mdistBosque">
          550m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="600mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="600m">
        <label class="form__label" for="600mdistBosque">
          600m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="650mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="650m">
        <label class="form__label" for="650mdistBosque">
          650m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="700mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="700m">
        <label class="form__label" for="700mdistBosque">
          700m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="750mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="750m">
        <label class="form__label" for="750mdistBosque">
          750m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="800mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="800m">
        <label class="form__label" for="800mdistBosque">
          800m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="850mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="850m">
        <label class="form__label" for="850mdistBosque">
          850m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="900mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="900m">
        <label class="form__label" for="900mdistBosque">
          900m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="950mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="950m">
        <label class="form__label" for="950mdistBosque">
          950m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="1kdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="1km">
        <label class="form__label" for="1kdistBosque">
          1km
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="mas1kdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="Más de 1km">
        <label class="form__label" for="mas1kdistBosque">
          Más de 1km
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('distCuerpoAgua') && submitted">
      <label class="form__label form__label--required">
        31. Distancia en metros entre el sitio del ataque y el
        cuerpo de agua más cercano (río, riachuelo, quebrada, canal, etc)
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="menos50mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="Menos de 50m">
        <label class="form__label" for="menos50mdistCuerpoAgua">
          Menos de 50m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="50mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="50m">
        <label class="form__label" for="50mdistCuerpoAgua">
          50m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="100mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="100m">
        <label class="form__label" for="100mdistCuerpoAgua">
          100m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="150mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="150m">
        <label class="form__label" for="150mdistCuerpoAgua">
          150m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="200mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="200m">
        <label class="form__label" for="200mdistCuerpoAgua">
          200m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="250mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="250m">
        <label class="form__label" for="250mdistCuerpoAgua">
          250m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="300mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="300m">
        <label class="form__label" for="300mdistCuerpoAgua">
          300m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="350mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="350m">
        <label class="form__label" for="350mdistCuerpoAgua">
          350m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="400mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="400m">
        <label class="form__label" for="400mdistCuerpoAgua">
          400m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="450mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="450m">
        <label class="form__label" for="450mdistCuerpoAgua">
          450m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="500mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="500m">
        <label class="form__label" for="500mdistCuerpoAgua">
          500m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="550mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="550m">
        <label class="form__label" for="550mdistCuerpoAgua">
          550m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="600mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="600m">
        <label class="form__label" for="600mdistCuerpoAgua">
          600m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="650mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="650m">
        <label class="form__label" for="650mdistCuerpoAgua">
          650m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="700mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="700m">
        <label class="form__label" for="700mdistCuerpoAgua">
          700m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="750mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="750m">
        <label class="form__label" for="750mdistCuerpoAgua">
          750m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="800mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="800m">
        <label class="form__label" for="800mdistCuerpoAgua">
          800m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="850mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="850m">
        <label class="form__label" for="850mdistCuerpoAgua">
          850m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="900mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="900m">
        <label class="form__label" for="900mdistCuerpoAgua">
          900m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="950mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="950m">
        <label class="form__label" for="950mdistCuerpoAgua">
          950m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="1kdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="1km">
        <label class="form__label" for="1kdistCuerpoAgua">
          1km
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="mas1kdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="Más de 1km">
        <label class="form__label" for="mas1kdistCuerpoAgua">
          Más de 1km
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('valor-animal-atacado') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="number"
      class="form__input"
      v-model.number="form.valorAnimalAtacado"
      required
      name="valor-animal-atacado"
      v-validate="'required'">
      <label class="form__label">32. Valor aproximado en colones del animal atacado</label>
    </form-group>

    <form-group :error="errors.has('ver-huellas-depredador') && submitted">
      <label class="form__label form__label--required">
        33. ¿Logró ver las huellas del posible depredador?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.verHuellasDepredador"
        id="siverHuellasDepredador"
        name="ver-huellas-depredador"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="siverHuellasDepredador">Si</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.verHuellasDepredador"
        id="noverHuellasDepredador"
        name="ver-huellas-depredador"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="noverHuellasDepredador">
          No
        </label>
      </div>
      <form-group :error="errors.has('imagen-huellas') && submitted"
      v-if="form.verHuellasDepredador">
        <div class="identado" v-if="form.verHuellasDepredador">
          <label class="form__label form__label--required">
            ¿A cual de estas se parece?
          </label>
          <p class="text">
            OPCIONAL: Si el ganadero tiene registro fotográfico, pedírsela y adjuntarla en el bloque
            &quot;Adjuntos&quot;
          </p>
        </div>
        <div class="flex--container">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.huellasDepredador"
          id="1huellasDepredador"
          name="imagen-huellas"
          v-validate="'required'"
          value="1">
          <label class="form__label" for="1huellasDepredador">
            <img src="/huella-coyote.jpg" width="100%">
          </label>
        </div>
        <div class="flex--container">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.huellasDepredador"
          id="2huellasDepredador"
          name="imagen-huellas"
          v-validate="'required'"
          value="2">
          <label class="form__label" for="2huellasDepredador">
            <img src="/huella-jaguar.jpg" width="100%">
          </label>
        </div>
        <div class="flex--container">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.huellasDepredador"
          id="3huellasDepredador"
          name="imagen-huellas"
          v-validate="'required'"
          value="3">
          <label class="form__label" for="3huellasDepredador">
            <img src="/huella-puma.jpg" width="100%">
          </label>
        </div>
        <div class="flex--container">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.huellasDepredador"
          id="4huellasDepredador"
          name="imagen-huellas"
          v-validate="'required'"
          value="4">
          <label class="form__label" for="4huellasDepredador">
            <img src="/huella-ocelote.jpg" width="100%">
          </label>
        </div>
      </form-group>
    </form-group>

  </form>
</template>

<script>
export default {
  name: "FormPerrosBloque4",
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
  methods: {
    validar,
  },
};

function validar() {
  return this.$validator.validate();
}
</script>
